export function getTimeZoneText(timeZoneId) {
  if (timeZoneId === 'Asia/Jakarta') return 'WIB';
  else if (timeZoneId === 'Asia/Makassar') return 'WITA';
  else if (timeZoneId === 'Asia/Jayapura') return 'WIT';

  return '';
}
